import { useEffect, useState } from "react";
import { getSubjectQuery } from "utils/apis/subject";
import { getUserByIdQuery } from "utils/apis/user";

type PageHeader = {
  subjectNumber: string;
  subjectName: string;
  inChargeName: string;
};

const initialPageHeader: PageHeader = {
  subjectNumber: "",
  subjectName: "",
  inChargeName: "",
};

const getSubject = async (subjectid: string) => {
  return await getSubjectQuery(subjectid);
};

const getUser = async (userId: string) => {
  return await getUserByIdQuery(userId);
};

export const usePageHeader = (subjectid: string) => {
  const [pageHeader, setPageHeader] = useState<PageHeader>(initialPageHeader);

  const fetchPageHeader = async (subjectId: string) => {
    try {
      const targetSubject = await getSubject(subjectId);
      if (targetSubject === undefined) return;

      if (!targetSubject.main_user_id_group) {
        setPageHeader({
          subjectNumber: targetSubject.subject_number,
          subjectName: targetSubject.subject_name
            ? targetSubject.subject_name
            : "",
          inChargeName: "",
        });
        return;
      }

      const targetUser = await getUser(targetSubject.main_user_id_group);

      setPageHeader({
        subjectNumber: targetSubject.subject_number,
        subjectName: targetSubject.subject_name
          ? targetSubject.subject_name
          : "",
        inChargeName: targetUser?.name ? targetUser.name : "",
      });
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchPageHeader(subjectid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subjectid]);

  return { pageHeader };
};
